import React from 'react';
import { Table, Select, Space, Pagination } from 'antd';
import styles from './index.module.less';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const CustomTable = ({
  data,
  pagination,
  showPaginationMeta = false,
  ...rest
}) => {
  const hasPagination =
    pagination !== false &&
    pagination !== null &&
    typeof pagination === 'object';

  const paginationConfig = hasPagination ? pagination : {};
  const total = paginationConfig.total || 0;
  const pageSize = paginationConfig.pageSize || 10;
  const current = paginationConfig.current || 1;
  const onChange = paginationConfig.onChange;
  const size = paginationConfig.size;

  const start = total === 0 ? 0 : (current - 1) * pageSize + 1;
  const end = Math.min(current * pageSize, total);

  return (
    <div
      className={`${styles.custom_table_container}${
        !data?.length ? ` ${styles.no_data}` : ''
      }`}
    >
      <Table
        dataSource={data}
        pagination={hasPagination ? false : pagination}
        {...rest}
      />
      {hasPagination && (
        <div className={styles.pagination_footer}>
          {showPaginationMeta ? (
            <Space size={8}>
              {total > 0 && (
                <span style={{ color: '#595959', fontSize: 13 }}>
                  {`Showing ${start.toLocaleString()}–${end.toLocaleString()} of ${total.toLocaleString()} records`}
                </span>
              )}
              <span style={{ color: '#8c8c8c', fontSize: 13 }}>|</span>
              <span style={{ color: '#595959', fontSize: 13 }}>
                Rows per page:
              </span>
              <Select
                value={pageSize}
                onChange={(newSize) => onChange?.(1, newSize)}
                style={{ width: 80 }}
                size="small"
                options={PAGE_SIZE_OPTIONS.map((v) => ({
                  label: String(v),
                  value: v
                }))}
              />
            </Space>
          ) : (
            <span />
          )}
          <Pagination
            {...paginationConfig}
            size={size || 'small'}
            total={total}
            pageSize={pageSize}
            current={current}
            showSizeChanger={false}
            showTotal={undefined}
            onChange={(p) => onChange?.(p, pageSize)}
          />
        </div>
      )}
    </div>
  );
};

export default CustomTable;
